import React, { useState, useRef } from 'react'
import classNames from 'classnames'
import { useStore } from 'src/state'
import CardGrid from 'src/components/card-grid'
import TrainerCard from 'src/components/trainer-card'
import Page from 'src/components/page'
import Button from 'src/components/button'
import BoxButton from 'src/components/box-button'
import Link from 'src/components/link'
import Container from 'src/components/container'
import HeroSection from 'src/components/hero-section'
import Section from 'src/components/section'
import AspectBox from 'src/components/aspect-box'
import Picture from 'src/components/picture'
import GallerySection from 'src/components/gallery-section'
import chevron from 'src/assets/about-chevron.svg'
import expandBtn from 'src/assets/expand-btn.svg'
import retractBtn from 'src/assets/retract-btn.svg'
import scheduleLeftArrow from 'src/assets/schedule-left-arrow.svg'
import scheduleRightArrow from 'src/assets/schedule-right-arrow.svg'

const AboutPage = () => {
  const {
    trainers,
    aboutPage: {
      hero,
      gallery,
      sessions,
      classes,
      scheduleSection,
      gallery2,
      featured,
      servicesSection,
      team,
    },
  } = useStore()
  const [maxTrainerCards, setMaxTrainerCards] = useState(6)
  const showingAllTrainers = maxTrainerCards > trainers.length
  const sessionsScrollTarget = useRef()
  const classesScrollTarget = useRef()
  const [serviceId, setServiceId] = useState(null)
  const [currentNycWeek, setCurrentNycWeek] = useState(
    scheduleSection.nycWeeks[0]
  )
  const [currentLaWeek, setCurrentLaWeek] = useState(scheduleSection.laWeeks[0])

  const prevNycWeek = () => {
    const currentIndex = scheduleSection.nycWeeks.indexOf(currentNycWeek)
    let index = currentIndex - 1
    if (index < 0) index = scheduleSection.nycWeeks.length - 1
    setCurrentNycWeek(scheduleSection.nycWeeks[index])
  }
  const nextNycWeek = () => {
    const currentIndex = scheduleSection.nycWeeks.indexOf(currentNycWeek)
    let index = currentIndex + 1
    if (index > scheduleSection.nycWeeks.length - 1) index = 0
    setCurrentNycWeek(scheduleSection.nycWeeks[index])
  }
  const prevLaWeek = () => {
    const currentIndex = scheduleSection.laWeeks.indexOf(currentLaWeek)
    let index = currentIndex - 1
    if (index < 0) index = scheduleSection.laWeeks.length - 1
    setCurrentLaWeek(scheduleSection.laWeeks[index])
  }
  const nextLaWeek = () => {
    const currentIndex = scheduleSection.laWeeks.indexOf(currentLaWeek)
    let index = currentIndex + 1
    if (index > scheduleSection.laWeeks.length - 1) index = 0
    setCurrentLaWeek(scheduleSection.laWeeks[index])
  }

  const isFirstNycWeek = scheduleSection.nycWeeks.indexOf(currentNycWeek) === 0
  const isLastNycWeek =
    scheduleSection.nycWeeks.indexOf(currentNycWeek) ===
    scheduleSection.nycWeeks.length - 1
  const isFirstLaWeek = scheduleSection.laWeeks.indexOf(currentLaWeek) === 0
  const isLastLaWeek =
    scheduleSection.laWeeks.indexOf(currentLaWeek) ===
    scheduleSection.laWeeks.length - 1

  return (
    <Page className="page-about">
      <HeroSection
        title={hero.title}
        backgroundImage={hero.backgroundImage}
        backgroundVideoUrl={hero.backgroundVideoUrl}
        shouldShowChevron={false}
      />
      <Section className="scroll-menu">
        <Button
          className="scroll-menu-item scroll-sessions"
          onClick={() => sessionsScrollTarget.current.scrollIntoView()}
        >
          <div className="text">{hero.scrollToSessionsText}</div>
          <Picture className="chevron" image={chevron} />
        </Button>
        <div className="vrule" />
        <Button
          className="scroll-menu-item scroll-classes"
          onClick={() => classesScrollTarget.current.scrollIntoView()}
        >
          <div className="text">{hero.scrollToClassesText}</div>
          <Picture className="chevron" image={chevron} />
        </Button>
      </Section>
      <GallerySection
        className="gallery-1"
        reversed
        centeredText
        {...gallery}
      />
      <div className="scroll-target" ref={sessionsScrollTarget} />
      <GallerySection className="sessions" images={sessions.images}>
        <h3 className="title">{sessions.title}</h3>
        <p className="description">{sessions.description}</p>
        <p className="ctas-title">{sessions.mailToLinksTitle}</p>
        <div className="ctas">
          <Link className="cta" to={sessions.mailToLinksButtonUrl1}>
            <BoxButton>{sessions.mailToLinksButtonText1}</BoxButton>
          </Link>
          <Link className="cta" to={sessions.mailToLinksButtonUrl2}>
            <BoxButton>{sessions.mailToLinksButtonText2}</BoxButton>
          </Link>
          <Link className="cta" to={sessions.mailToLinksButtonUrl3}>
            <BoxButton>{sessions.mailToLinksButtonText3}</BoxButton>
          </Link>
        </div>
      </GallerySection>
      <div className="scroll-target" ref={classesScrollTarget} />
      <Section className="classes">
        <Container>
          <AspectBox x={720} y={864}>
            <Picture defaultWidth={1000} image={classes.image} fitWidth cover />
          </AspectBox>
          <div className="copy">
            <h3 className="title">{classes.title}</h3>
            <p className="description">{classes.description}</p>
            <p className="ctas-title">{classes.mailToLinksTitle}</p>
            <div className="ctas">
              <Link className="cta" to={classes.mailToLinksButtonUrl1}>
                <BoxButton>{classes.mailToLinksButtonText1}</BoxButton>
              </Link>
              <Link className="cta" to={classes.mailToLinksButtonUrl2}>
                <BoxButton>{classes.mailToLinksButtonText2}</BoxButton>
              </Link>
            </div>
          </div>
        </Container>
      </Section>
      <Section className="schedule">
        <Container>
          <div className="head">
            <h3 className="title size-medium">{scheduleSection.title}</h3>
            <p className="description">{scheduleSection.description}</p>
          </div>
          <div className="tables">
            <div className="table nyc-table">
              <div className="table-head">
                <div className="week-of">{currentNycWeek.weekOfText}</div>
                <h3 className="title size-medium">
                  {scheduleSection.nycTitle}
                </h3>
                <div className="nav">
                  <Button
                    className={classNames(isFirstNycWeek && 'disabled')}
                    onClick={prevNycWeek}
                  >
                    <Picture
                      className={classNames(
                        'left-arrow',
                        isFirstNycWeek && 'disabled'
                      )}
                      image={scheduleLeftArrow}
                    />
                  </Button>
                  <Button
                    className={classNames(isLastNycWeek && 'disabled')}
                    onClick={nextNycWeek}
                  >
                    <Picture
                      className="right-arrow"
                      image={scheduleRightArrow}
                    />
                  </Button>
                </div>
              </div>
              <div className="table-body">
                <div className="weeks">
                  {scheduleSection.nycWeeks.map((week) => (
                    <div
                      key={week.id}
                      className={classNames(
                        'week',
                        currentNycWeek === week && 'current'
                      )}
                    >
                      {week.classes.map((clazz) => (
                        <div
                          key={clazz.id}
                          className={classNames(
                            'class',
                            clazz.scheduled && 'scheduled'
                          )}
                        >
                          <div className="col date">{clazz.date}</div>
                          <div className="col time">{clazz.time}</div>
                          <h3 className="col name">{clazz.name}</h3>
                          <div className="col instructor">
                            {clazz.instructor}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
              <div className="table-footer">
                <Link to={scheduleSection.nycButtonUrl}>
                  <BoxButton>{scheduleSection.nycButtonText}</BoxButton>
                </Link>
              </div>
            </div>
            <div className="table la-table">
              <div className="table-head">
                <div className="week-of">{currentLaWeek.weekOfText}</div>
                <h3 className="title size-medium">{scheduleSection.laTitle}</h3>
                <div className="nav">
                  <Button
                    className={classNames(isFirstLaWeek && 'disabled')}
                    onClick={prevLaWeek}
                  >
                    <Picture className="left-arrow" image={scheduleLeftArrow} />
                  </Button>
                  <Button
                    className={classNames(isLastLaWeek && 'disabled')}
                    onClick={nextLaWeek}
                  >
                    <Picture
                      className="right-arrow"
                      image={scheduleRightArrow}
                    />
                  </Button>
                </div>
              </div>
              <div className="table-body">
                <div className="weeks">
                  {scheduleSection.laWeeks.map((week) => (
                    <div
                      key={week.id}
                      className={classNames(
                        'week',
                        currentLaWeek === week && 'current'
                      )}
                    >
                      {week.classes.map((clazz) => (
                        <div
                          key={clazz.id}
                          className={classNames(
                            'class',
                            clazz.scheduled && 'scheduled'
                          )}
                        >
                          <div className="col date">{clazz.date}</div>
                          <div className="col time">{clazz.time}</div>
                          <h3 className="col name">{clazz.name}</h3>
                          <div className="col instructor">
                            {clazz.instructor}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
              <div className="table-footer">
                <Link to={scheduleSection.laButtonUrl}>
                  <BoxButton>{scheduleSection.laButtonText}</BoxButton>
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </Section>
      <GallerySection className="gallery-2" centeredText {...gallery2} />
      <Section className="featured">
        <Container>
          <h3 className="section-title grey centered">{featured.title}</h3>
          <div className="features">
            {featured.features.map(({ id, url, image }) => (
              <Picture
                className="feature"
                key={id}
                image={image}
                fitWidth
                contain
              />
            ))}
          </div>
        </Container>
      </Section>
      <Section className="services">
        <Container>
          <h3 className="section-title centered">{servicesSection.title}</h3>
          <p className="section-subtitle centered">
            {servicesSection.subtitle}
          </p>
          <div className="services">
            {servicesSection.services.map(({ id, title, body }) => (
              <div
                className={classNames(
                  'service',
                  serviceId === id && 'expanded'
                )}
                key={id}
              >
                <Button
                  className="title-container"
                  onClick={() => setServiceId(id)}
                >
                  <h2>{title}</h2>
                  <Picture
                    className="expand-btn"
                    image={expandBtn}
                    fitWidth
                    contain
                  />
                </Button>
                <div className="body-container">
                  <div className="details">
                    <h2>{title}</h2>
                    <p>{body}</p>
                  </div>
                  <Button
                    className="retract-btn"
                    onClick={() => setServiceId(null)}
                  >
                    <Picture fitWidth contain image={retractBtn} />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Section>
      <Section className="team">
        <Container>
          <h3 className="section-title size-big grey centered">{team.title}</h3>
          <CardGrid maxCards={maxTrainerCards}>
            {trainers.map((trainer) => (
              <TrainerCard key={trainer.id} {...trainer} />
            ))}
          </CardGrid>
          {!showingAllTrainers && (
            <Button
              className="more-btn centered"
              onClick={() => setMaxTrainerCards(Infinity)}
            >
              <span className="action-text size-big">
                {team.moreButtonText}
              </span>
            </Button>
          )}
        </Container>
      </Section>
    </Page>
  )
}

export default AboutPage
